export function generateStars(average) {
	// const ranges = [
	// 	{ min: 1, max: 1.3, value: 1 },
	// 	{ min: 1.4, max: 1.8, value: 1.5 },
	// 	{ min: 1.9, max: 2.3, value: 2 },
	// 	{ min: 2.4, max: 2.8, value: 2.5 },
	// 	{ min: 2.9, max: 3.3, value: 3 },
	// 	{ min: 3.4, max: 3.8, value: 3.5 },
	// 	{ min: 3.9, max: 4.3, value: 4 },
	// 	{ min: 4.4, max: 4.8, value: 4.5 },
	// 	{ min: 4.9, max: 5, value: 5 },
	// ];
	// const rounded = ranges.find((r) => average >= r.min && average <= r.max)?.value || 0;
	const rounded = Math.round(average * 2) / 2;
	
	const stars = [];
	
	for (let i = 1; i <= 5; i++) {
		if (rounded >= i) {
			stars.push('fas fa-star');
		} else if (rounded + 0.5 >= i) {
			stars.push('fas fa-star-half-alt');
		} else {
			stars.push('far fa-star');
		}
	}
	
	return stars;
}
